import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SportMapItem } from '../../definitions/sport-map-item';
import { MapItemComponent } from '@ui/shared/util-map';

import { DetailViewModule } from '@ui/shared/ui-detail-view';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-sport-map-item-popup-content',
    templateUrl: './sport-map-item-popup-content.component.html',
    styleUrls: ['./sport-map-item-popup-content.component.scss'],
    imports: [
        DetailViewModule,
    ],
})
export class SportMapItemPopupContentComponent implements MapItemComponent<SportMapItem> {
    public mapItem = input<SportMapItem | undefined>();
}
